import * as React from 'react';
import { FC } from 'react';
import { MenuItemLink, usePermissions } from 'react-admin';
import { useLocation } from 'react-router-dom';
import AppsIcon from '@material-ui/icons/Apps';
import HomeIcon from '@material-ui/icons/Home';
import ContentIcon from '@material-ui/icons/Description';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import staff from '../../staff';
import winners from '../../winners';
import blogs from '../../blogs';
import bonusDraw from '../../bonusDraw';
import widgets from '../../widgets';
import FlagIcon from '@material-ui/icons/Flag';
import SettingsIcon from '@material-ui/icons/Settings';

import dreamHome from '../../dreamHome';
import prizes from '../../lifestylePrizes/index';
import getRoute from '../../../helpers/getRoute';
import SubMenu from './SubMenu';
import fixedOdds from '../../fixedOdds/index';
import { checkSubMenuPermissions } from '../../../helpers/checkPermissions';
import refferals from '../../refferals';
import reports from '../../reports';
import general from '../../general';
import specialOffers from '../../specialOffers';
interface Props {
  logout: () => void;
}

const Menu: FC<Props> = ({}) => {
  let { permissions } = usePermissions();

  const [open, handleOpen] = React.useState('');
  const handleToggle = (item: string): void => {
    if (item === open) {
      handleOpen('');
      return;
    }
    handleOpen(item);
  };
  const location = useLocation();
  const currentRoute = getRoute(location.pathname);
  React.useEffect(() => {
    handleOpen(currentRoute);
  }, []);
  const handleClick = (item: string) => {
    // if (item === open) return handleOpen("");
    handleOpen(item);
  };
  return (
    <div className='menu-wrap'>
      {/* <MenuItemLink
        to='/homes'
        primaryText='Home Page'
        leftIcon={<HomeIcon />}
        onClick={() => handleClick('homes')}
        className={currentRoute === 'homes' ? 'link-active' : 'link'}
      /> */}
      <MenuItemLink
        to='/content'
        primaryText='Home Page'
        leftIcon={<HomeIcon />}
        onClick={() => handleClick('generalContent')}
        className={currentRoute === 'generalContent' ? 'link-active' : 'link'}
      />
      {checkSubMenuPermissions(permissions, [
        'Dream home',
        'Lifestyle Prizes',
        'Fixed Odds',
      ]) && (
        <SubMenu
          handleToggle={() => handleToggle('prizeManagement')}
          isOpen={
            open === 'prizeManagement' ||
            open === 'dreamHome' ||
            open === 'prizes' ||
            open === 'fixedOdds' ||
            open === 'weeklySubscriptionDraws'
          }
          sidebarIsOpen={
            open === 'prizeManagement' ||
            open === 'dreamHome' ||
            open === 'prizes' ||
            open === 'fixedOdds' ||
            open === 'weeklySubscriptionDraws'
          }
          name='Prize Management'
          icon={<AppsIcon />}
        >
          {checkSubMenuPermissions(permissions, ['Dream home']) && (
            <MenuItemLink
              to={`/dreamHome`}
              primaryText={'Dream home'}
              leftIcon={<dreamHome.icon />}
              onClick={() => handleClick('dreamHome')}
              className={currentRoute === 'dreamHome' ? 'link-active' : 'link'}
            />
          )}
          {checkSubMenuPermissions(permissions, ['Dream home']) && (
            <MenuItemLink
              to={`/weeklySubscriptionDraws`}
              primaryText={'Weekly Subscription'}
              leftIcon={<dreamHome.icon />}
              onClick={() => handleClick('weeklySubscriptionDraws')}
              className={
                currentRoute === 'weeklySubscriptionDraws'
                  ? 'link-active'
                  : 'link'
              }
            />
          )}
          {checkSubMenuPermissions(permissions, ['Lifestyle Prizes']) && (
            <MenuItemLink
              to={`/prizes`}
              primaryText='Lifestyle Prizes'
              leftIcon={<prizes.icon />}
              onClick={() => handleClick('prizes')}
              className={currentRoute === 'prizes' ? 'link-active' : 'link'}
            />
          )}
          {checkSubMenuPermissions(permissions, ['Fixed Odds']) && (
            <MenuItemLink
              to={`/fixedOdds`}
              primaryText='Fixed Odds'
              leftIcon={<fixedOdds.icon />}
              onClick={() => handleClick('fixedOdds')}
              className={currentRoute === 'fixedOdds' ? 'link-active' : 'link'}
            />
          )}
        </SubMenu>
      )}
      {checkSubMenuPermissions(permissions, ['Competitions']) && (
        <MenuItemLink
          to='/competitions'
          primaryText='Competition'
          leftIcon={<FlagIcon />}
          onClick={() => handleClick('competitions')}
          className={currentRoute === 'competitions' ? 'link-active' : 'link'}
        />
      )}
      <MenuItemLink
        to='/bonusDraw'
        primaryText='Bonus Draw'
        leftIcon={<bonusDraw.icon />}
        onClick={() => handleClick('bonusDraw')}
        className={currentRoute === 'bonusDraw' ? 'link-active' : 'link'}
      />
      {checkSubMenuPermissions(permissions, ['User management']) && (
        <>
          <MenuItemLink
            to={`/users`}
            primaryText='User management'
            leftIcon={<SupervisedUserCircleIcon />}
            onClick={() => handleClick('users')}
            className={currentRoute === 'users' ? 'link-active' : 'link'}
          />
        </>
      )}
      {checkSubMenuPermissions(permissions, ['Staff management']) && (
        <MenuItemLink
          to={'/staffUsers'}
          primaryText='Staff management'
          leftIcon={<staff.icon />}
          onClick={() => handleClick('staffUsers')}
          className={currentRoute === 'staffUsers' ? 'link-active' : 'link'}
        />
      )}
      <MenuItemLink
        to='/blogs'
        primaryText='Blog'
        leftIcon={<blogs.icon />}
        onClick={() => handleClick('blogs')}
        className={currentRoute === 'blogs' ? 'link-active' : 'link'}
      />
      <SubMenu
        handleToggle={() => handleToggle('settings')}
        isOpen={
          open === 'settings' ||
          open === 'winners' ||
          // open === 'widgets' ||
          open === 'referrals' ||
          open === 'general' ||
          open === 'specialOffers'
        }
        sidebarIsOpen={
          open === 'settings' ||
          open === 'winners' ||
          // open === 'widgets' ||
          open === 'referrals' ||
          open === 'general' ||
          open === 'specialOffers'
        }
        name='Settings'
        icon={<SettingsIcon />}
      >
        {checkSubMenuPermissions(permissions, ['General']) && (
          <MenuItemLink
            to={'/general'}
            primaryText='General'
            leftIcon={<general.icon />}
            onClick={() => handleClick('general')}
            className={currentRoute === 'general' ? 'link-active' : 'link'}
          />
        )}
        {checkSubMenuPermissions(permissions, ['Winners']) && (
          <MenuItemLink
            to={'/winners'}
            primaryText='Winners'
            leftIcon={<winners.icon />}
            onClick={() => handleClick('winners')}
            className={currentRoute === 'winners' ? 'link-active' : 'link'}
          />
        )}
        {/* {checkSubMenuPermissions(permissions, ['Winners']) && (
          <MenuItemLink
            to={'/widgets'}
            primaryText='Widgets'
            leftIcon={<winners.icon />}
            onClick={() => handleClick('widgets')}
            className={currentRoute === 'widgets' ? 'link-active' : 'link'}
          />
        )} */}
        {checkSubMenuPermissions(permissions, ['Referrals']) && (
          <MenuItemLink
            to={'/referrals'}
            primaryText='Refferals'
            leftIcon={<refferals.icon />}
            onClick={() => handleClick('referrals')}
            className={currentRoute === 'referrals' ? 'link-active' : 'link'}
          />
        )}
      </SubMenu>
      <SubMenu
        handleToggle={() => handleToggle('landingSettings')}
        isOpen={
          open === 'landingSettings' ||
          open === 'landing-general' ||
          open === 'win-general' ||
          open === 'discount-general' ||
          open === 'deal-general'
          // open === 'thesun-general' ||
          // paths.includes(open)
        }
        sidebarIsOpen={
          open === 'landingSettings' ||
          open === 'landing-general' ||
          open === 'win-general' ||
          open === 'discount-general' ||
          open === 'deal-general'
          // open === 'thesun-general' ||
          // paths.includes(open)
        }
        name='Landing Settings'
        icon={<SettingsIcon />}
      >
        <MenuItemLink
          to={'/win-general'}
          primaryText='Win General'
          leftIcon={<general.icon />}
          onClick={() => handleClick('win-general')}
          className={currentRoute === 'win-general' ? 'link-active' : 'link'}
        />
        <MenuItemLink
          to={'/discount-general'}
          primaryText='Discount General'
          leftIcon={<general.icon />}
          onClick={() => handleClick('discount-general')}
          className={
            currentRoute === 'discount-general' ? 'link-active' : 'link'
          }
        />
        {/* <MenuItemLink
          to={'/thesun-general'}
          primaryText='The Sun General'
          leftIcon={<general.icon />}
          onClick={() => handleClick('discount-general')}
          className={
            currentRoute === 'discount-general' ? 'link-active' : 'link'
          }
        /> */}
        <MenuItemLink
          to={'/deal-general'}
          primaryText='Deal General'
          leftIcon={<general.icon />}
          onClick={() => handleClick('deal-general')}
          className={currentRoute === 'deal-general' ? 'link-active' : 'link'}
        />
        <MenuItemLink
          to={'/offer-general'}
          primaryText='Offer General'
          leftIcon={<general.icon />}
          onClick={() => handleClick('offer-general')}
          className={currentRoute === 'offer-general' ? 'link-active' : 'link'}
        />
      </SubMenu>
      <MenuItemLink
        to='/reports'
        primaryText='Reports'
        leftIcon={<reports.icon />}
        onClick={() => handleClick('reports')}
        className={currentRoute === 'reports' ? 'link-active' : 'link'}
      />
      <MenuItemLink
        to='/widgets'
        primaryText='Widgets'
        leftIcon={<reports.icon />}
        onClick={() => handleClick('widgets')}
        className={currentRoute === 'widgets' ? 'link-active' : 'link'}
      />
    </div>
  );
};

export default Menu;
